import Vue from "vue";
import {DateTime} from "luxon";

/* debounced computed property, WARNING still not working with fn that tries to call 'this' */
function debounce(fn, delay) {
    let timeoutID = null;
    return (...args) => {
        clearTimeout(timeoutID);
        timeoutID = setTimeout(() => fn(...args), delay)
    }
}
export function debouncedComputedProperty(delay, initialData) {
    let obs = Vue.observable({ value: initialData });
    return {
        get() { return obs.value; },
        set: debounce( newVal => { obs.value = newVal; }, delay)
    }
}

export function filterRows(rows, filters) {
    let filterAsList = Object.entries(filters)
        .map(([field, filterValue]) => [field, typeof filterValue === 'string' ? filterValue.trim() : filterValue])
        .filter(([_, filterValue]) => !!filterValue || filterValue === false);

    return rows.filter(row =>
        filterAsList.every(([f, filVal]) => {
            if (filVal === undefined || filVal === '') {
                return true;
            }
            let path = f.split('.');
            let rowVal = row;
            for (let p of path) {
                rowVal = rowVal[p];
            }
            if (typeof filVal === 'string') {
                if (typeof rowVal === 'number') {
                    rowVal = rowVal.toString();
                } else if (rowVal && typeof rowVal === 'object') {
                    rowVal = JSON.stringify(rowVal);
                } else if (typeof rowVal !== 'string') {
                    return false;
                }
                rowVal = rowVal.toLowerCase();
                filVal = filVal.toLowerCase().trim().replace(/\s\s+/g, ' ').split(' ');
                return filVal.every(fragment => rowVal.includes(fragment));
            }
            else if (typeof filVal === 'boolean') {
                return rowVal === filVal;
            }

            /* catch all */
            return true;
        })
    );
}

export function currencyToSymbol(currency) {
    currency = typeof currency === 'string' ? currency.toUpperCase() : '';
    if (currency === "GBP") {
        return '£';
    } else if (currency === "EUR") {
        return '€';
    } else {
        return '$';
    }
}

export function convertUTCToLocal(timeUTC, format = 'yyyy-MM-dd HH:mm:ss') {
    if (!timeUTC) {
        return null;
    }
    return DateTime
        .fromFormat(timeUTC, format, {zone: 'utc'})
        .toLocal()
        .toFormat(format);
}

/* luxon date computed property */
function fromIsoTime(isoTime) {
    return isoTime ? DateTime.fromISO(isoTime).toFormat('yyyy-MM-dd') : null
}
function toIsoTime(crudeTime) {
    return crudeTime ? DateTime.fromFormat(crudeTime, 'yyyy-MM-dd').toISO() : null
}
export function luxonDateComputedProperty(path) {
    if (typeof path === 'string') {
        path = [path];
    }
    return {
        get() {
            let v = this;
            for (let element of path) {
                v = v[element];
            }
            return toIsoTime(v);
        },
        set(value) {
            let v = this;
            for (let i = 0; i < path.length-1; i++) {
                v = v[path[i]];
            }
            v[path[path.length -1]] = fromIsoTime(value);
        }
    }
}

export function initPropertyOfMultiSelect(obj, origin, created, bank) {
    if (!obj[origin]) {
        return;
    }
    let filteredBank = [];
    for (let id of obj[origin]) {
        let found = bank.find(e => e.id === id)
        if (found) {
            filteredBank.push(found)
        }
    }
    Vue.set(obj, created, filteredBank)
}

export function assignIdsOfMultiSelect(obj, origin, created) {
    if (!obj[created]) {
        return ;
    }
    obj[origin] = [];
    for (let item of obj[created]) {
        if (item && obj[origin].indexOf(item.id || item.value) === -1) {
            obj[origin].push(item.id || item.value);
        }
    }
    delete obj[created];
    return obj;
}